import React from "react";
import { Link } from "react-router-dom";
import SafeImage from "./SafeImage";

export default function PageHero({ eyebrow, title, lede, image, primaryCta, secondaryCta, testId = "page-hero" }) {
  return (
    <section className="relative min-h-[60vh] flex items-end overflow-hidden" data-testid={testId}>
      <SafeImage
        src={image}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-28 pb-16 md:pb-24">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="eyebrow !text-bah-yellow">
              <span>{eyebrow}</span>
            </div>
          )}
          <h1 className="mt-5 font-display text-white text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
            {title}
          </h1>
          {lede && (
            <p className="mt-5 text-white/85 text-lg md:text-xl leading-relaxed max-w-2xl">
              {lede}
            </p>
          )}
          {(primaryCta || secondaryCta) && (
            <div className="mt-8 flex flex-wrap gap-3">
              {primaryCta &&
                (primaryCta.to ? (
                  <Link to={primaryCta.to} className="btn-primary" data-testid={`${testId}-primary`}>
                    {primaryCta.label}
                  </Link>
                ) : (
                  <a
                    href={primaryCta.href}
                    target={primaryCta.external ? "_blank" : undefined}
                    rel={primaryCta.external ? "noopener noreferrer" : undefined}
                    className="btn-primary"
                    data-testid={`${testId}-primary`}
                  >
                    {primaryCta.label}
                  </a>
                ))}
              {secondaryCta &&
                (secondaryCta.to ? (
                  <Link to={secondaryCta.to} className="btn-secondary" data-testid={`${testId}-secondary`}>
                    {secondaryCta.label}
                  </Link>
                ) : (
                  <a
                    href={secondaryCta.href}
                    target={secondaryCta.external ? "_blank" : undefined}
                    rel={secondaryCta.external ? "noopener noreferrer" : undefined}
                    className="btn-secondary"
                    data-testid={`${testId}-secondary`}
                  >
                    {secondaryCta.label}
                  </a>
                ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
